/**
 * Helpers per il download nativo browser di Blob (URL.createObjectURL + anchor).
 *
 * Estrae logica condivisa tra download singolo (GET) e download zip (POST).
 */

/**
 * Forza il download di un Blob con il nome dato.
 *
 * Firefox richiede che l'anchor sia in DOM perché il click programmatico
 * scarichi davvero. Revoke su tick successivo per non troncare il blob.
 */
export function saveBlobAs(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/**
 * Estrae il filename dall'header Content-Disposition.
 *
 * Preferisce `filename*=UTF-8''<percent-encoded>` (RFC 5987) se presente,
 * fallback a `filename="..."` ASCII (RFC 9110 §5.5).
 *
 * Ritorna `null` se l'header è assente / malformato.
 */
export function parseContentDispositionFilename(
  header: string | null | undefined
): string | null {
  if (!header) return null;

  // RFC 5987: `filename*=UTF-8''<encoded>` (preferito)
  const starMatch = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (starMatch) {
    try {
      return decodeURIComponent(starMatch[1].trim());
    } catch {
      /* fall through al legacy */
    }
  }

  // RFC 9110 §5.5: `filename="..."` (legacy ASCII)
  const quotedMatch = /filename\s*=\s*"([^"]*)"/i.exec(header);
  if (quotedMatch) return quotedMatch[1];

  // `filename=foo.zip` senza quote
  const bareMatch = /filename\s*=\s*([^;]+)/i.exec(header);
  if (bareMatch) return bareMatch[1].trim();

  return null;
}
